import { ELayout as ECompanyDashboardLayout } from "@/pages/dashboard/company/types.ts"

import { TConfig } from "../searchParams/config.ts"

// Keys to pick from searchParams TConfig
export const sharedKeys: (keyof TConfig)[] = [
  "companyDashboardLayout",
  "scope1Tab",
  "scope1FuelLayout",
  "reportingYear",
]
type SharedKeys = (typeof sharedKeys)[number]

// type mapping for all store keys
export interface TStore extends Pick<TConfig, SharedKeys> {
  bulbSectionCollapsed: boolean
  /**
   * Persists onboarding banner/checklist dismissals across sessions.
   * Keys are `${userId}_${bannerKey}` to scope by user and prevent
   * cross-account bleed on shared devices.
   */
  onboardingDismissed: Record<string, boolean>
}

// default values for store items, must be present if not set above as possibly undefined
export const defaultStoreData: TStore = Object.freeze({
  companyDashboardLayout: ECompanyDashboardLayout.dashboard,
  scope1Tab: 0,
  scope1FuelLayout: 0,
  bulbSectionCollapsed: false,
  onboardingDismissed: {},
})
